import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Stack, Typography } from "@mui/material";
import { ContentMainLayout } from "../../layout/contentLayout";
import useResponsive from "../../hooks/useResponsive";
import MessageList from "../../components/messages/MessageList";
import MessageInformation from "../../components/messages/MessageInformation";
import { useMessaging } from "../../hooks/useMessaging";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { set } from "react-hook-form";
import {
  SkeletonChatLoading,
  SkeletonChatMessageLoading,
} from "../../components/ui-elements/skeleton-loading";

const Messages: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useResponsive("down", "lg", "xl");
  const { updateChartHeader, selectChat, messages } = useMessaging();

  const chats = useSelector((state: RootState) => state.message.chats);
  const showChatMessages = useSelector(
    (state: RootState) => state.message.showChatMessages
  );

  const { fetchChats, loading } = useMessaging();

  // fetch the chat data
  useEffect(() => {
    if (chats?.length === 0) {
      // No chat selected, redirect to dashboard
      fetchChats();

      return;
    }
  }, []);
  

  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header>
          <Stack
            direction={"row"}
            spacing={1}
            sx={{ mt: 2 }}
            alignItems={"center"}
          >
            <Typography variant="h4" sx={{ fontWeight: 500 }}>
              Messages
            </Typography>
            {/* <Search placeholder="Search messages" /> */}
          </Stack>
        </Header>
        <ContentMainLayout>
          <Stack
            direction={"row"}
            spacing={4}
            justifyContent={isDesktop ? "center" : "space-between"}
          >
            <Stack
              width={isDesktop ? "35%" : "35%"}
              sx={{
                // display: isDesktop ? "none" : "block",
                display: "block",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  pt: "90px",
                }}
              >
                <MessageList
                  updateChartHeader={updateChartHeader}
                  chats={chats}
                  selectChat={selectChat}
                />
              </Box>
              {loading &&
                chats.length === 0 &&
                [...Array(5)].map((_, idx) => (
                  <Box key={idx}>
                    <SkeletonChatLoading />
                  </Box>
                ))}
            </Stack>
            <Stack width={isDesktop ? "90%" : "65%"}>
              {showChatMessages && (
                <Box
                  sx={{
                    width: "100%",
                    mx: "auto",
                    pt: "70px",
                  }}
                >
                  <MessageInformation />
                </Box>
              )}
              {!showChatMessages && (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    pt: "100px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {!loading && (
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>
                      Kindly Select a chat to view messages
                    </Typography>
                  )}
                </Box>
              )}

              {loading &&
                chats.length === 0 &&
                [...Array(5)].map((_, idx) => (
                  <Box key={idx}>
                    <SkeletonChatMessageLoading />
                  </Box>
                ))}
            </Stack>
          </Stack>
        </ContentMainLayout>
      </Box>
    </>
  );
};

export default Messages;
